import useSignoutQuery from '@src/hooks/queries/auth/signout/useSignoutQuery'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { CenterModalContext } from '@src/contexts/popup/modal/CenterModalProvider'
import vendorAtom from '@src/atom/vendor'
import { useRecoilState } from 'recoil'
import { getAnalytics, setUserId, setUserProperties } from 'firebase/analytics'

const useSignout = () => {
	const [_, setVendor] = useRecoilState(vendorAtom)
	const { openCenterModal, closeCenterModal } = useContext(CenterModalContext)
	const navigate = useNavigate()
	const { mutate } = useSignoutQuery()

	const onSignout = () => {
		mutate(
			{},
			{
				onSuccess: () => {
					// if (res.success !== 1) {
					// 	openCenterModal(
					// 		{ desc: '로그아웃에 실패했어요. 다시 시도해주세요.' },
					// 		() => closeCenterModal,
					// 	)
					// 	return
					// }
					setVendor(() => ({
						isLoggedIn: false,
						no: '',
						username: '',
						profileImg: '',
						brandName: '',
						role: '',
						description: '',
					}))

					const analytics = getAnalytics()
					setUserId(analytics, null)
					setUserProperties(analytics, {})

					navigate('/signin')
				},
				onError: () => {
					openCenterModal(
						{ desc: '로그아웃에 실패했어요. 다시 시도해주세요.' },
						() => closeCenterModal,
					)
				},
			},
		)
	}
	const getSignoutBtnProps = ({ ...otherProps } = {}) => ({
		onClick: onSignout,
		...otherProps,
	})
	return { getSignoutBtnProps }
}
export default useSignout
